import {
  CE_13,
  CATALOG_ENTRIES_DEFAULTS,
  hideCE13Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";
import { CATALOG_HOME_LINK_TYPE, FILTER_OPTIONS, URL_TYPE_OPTIONS } from "constants/stores/routes";

export const CE13_PLASMIC_PROPS = {
  heading: {
    type: "string",
    defaultValue: CATALOG_ENTRIES_DEFAULTS[CE_13].heading,
    description: "Section heading (CE13 only)",
    hidden: hideCE13Props,
  },
  catalogs: {
    type: "array",
    itemType: {
      type: "object",
      fields: {
        image: {
          type: "imageUrl",
        },
        imageAlt: {
          type: "string",
        },
        catalogTitle: {
          type: "string",
        },
        categoryLinkType: {
          type: "choice",
          options: URL_TYPE_OPTIONS,
          defaultValue: CATALOG_HOME_LINK_TYPE,
        },
        filterOptions: {
          type: "choice",
          options: FILTER_OPTIONS,
        },
        linkOpenInNewTab: {
          type: "boolean",
          defaultValue: false,
        },
        linkOtherUrl: {
          type: "string",
          defaultValue: "",
        },
        categorySlug: {
          type: "string",
          defaultValue: "",
        },
      },
    },
    defaultValue: CATALOG_ENTRIES_DEFAULTS[CE_13].catalogs,
    description: "Catalog items array (CE13 only)",
    hidden: hideCE13Props,
  },
  className: {
    type: "class",
    description: "Custom CSS class name for the section wrapper",
  },
};
